import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from './Header.jsx'
import Sidebar from './Sidebar.jsx'
import Footer from './Footer.jsx'
import BackToTop from './BackToTop.jsx'
import PersonBanner from './PersonBanner.jsx'
import { useScrollReveal } from '../hooks/useScrollReveal.js'

const pageTitles = {
  '/': 'Homepage',
  '/services': 'My Services',
  '/works': 'My Works',
  '/contact': 'Contact',
}

export default function Layout() {
  const location = useLocation()
  const [loading, setLoading] = useState(true)
  const pageName = pageTitles[location.pathname] || 'Noor Muhammad'
  useScrollReveal(location.pathname)

  // Original theme used swup + gsap to fade the preloader out and re-run
  // scroll-reveal ("mil-up") animations on every page change. Re-hook your
  // ported main.js init here if you bring it back in, e.g.:
  //   useEffect(() => { window.initPageAnimations?.() }, [location.pathname])
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 300)
    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return (
    <div className="mil-wrapper" id="top">
      {loading && (
        <div className="mil-preloader-frame">
          <div className="mil-preloader-content">
            <div className="mil-preloader">
              <div className="mil-circ-1"></div>
              <div className="mil-circ-2"></div>
              <div className="mil-circ-3"></div>
              <div className="mil-circ-4"></div>
            </div>
            <div className="mil-upper">Loading</div>
          </div>
        </div>
      )}

      <div className="mil-frame">
        <Header />
        <Sidebar pageName={pageName} />
        <BackToTop />
      </div>
      <Outlet />
      {/* <div className="mil-content">
        <div className="mil-scroll-wrapper" id="swupMain">
          <div className="mil-container">
            
            <Footer />
          </div>
        </div>

        <PersonBanner />
      </div> */}
    </div>
  )
}
